module.exports = __webpack_public_path__ + "fonts/qtzain_reguar_final.c2c5d94f.woff";